
  <footer class="footer-sign">
  <div class="footer-inner">
    <div class="footer-left">
      @if(!hideLogo) {
      <span class="footer-label">Powered by</span>
      <img src="./../../assets/logo.png" alt="AYAN Softwares" class="footer-logo" />
      }
    </div>

    <div class="footer-icons">
      <div class="footer-label">Also, available on</div>
      <div class="footer-icons-row">
        <a href="https://chromewebstore.google.com/detail/kaizen-esign/adhcdcjkdfniafmfahnlijlpdlmcdhog"
          target="_blank"
          rel="noopener">
          <img src="./../../assets/Chrome_icon.png" alt="Chrome Web Store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.ayankaizen.esign"
          target="_blank"
          rel="noopener"><img src="./../../assets/Google_Icon.png" alt="Google Play" /></a>
        <a href="https://apps.apple.com/in/iphone/search?term=kaizen%20esign"><img src="./../../assets/AppStore_Icon.png" alt="App Store" /></a>
        <a href="https://marketplace.microsoft.com/en-us/product/office/WA200008076?tab=Overview"
          target="_blank"
          rel="noopener"><img src="./../../assets/Outlook.png" alt="Outlook" /></a>
      </div>
    </div>

    <!--
    <div class="footer-legal">
      <div class="footer-label">Legally Compliant with</div>
      <div class="footer-legal-row">
        <img src="./../../assets/dsc_logo.png" alt="DSC" />
        <img src="./../../assets/AATL-LOGO-latest1.png" alt="AATL" />
      </div>
    </div>
    -->
  </div>




  <div class="footer-mobile-logo">
    @if(!hideLogo) {
    <img src="./../../assets/logo.png" alt="AYAN Softwares" class="footer-logo" />
    }
  </div>

  <div class="footer-line">
    <img src="./../../assets/footer_horizontal_Line.png" alt="footer line" style="width: 100%;" />
  </div>
</footer>




